<template>
  <div>
    <media-gallery @selected="selectedImage" v-if="!hasImage" :label="$t('pages.createQuestion.AddImageToQuestion')"
    :image-height="imageDimension.height" :image-width="imageDimension.width"
                   :save-original-file-type="imageDimension.saveOriginalFileType"
    />
    <div class="py-4" v-if="hasImage">
      <v-row align="center" justify="start" class="justify-sm-end">
        <div>
          <v-img :src="image" max-height="100" max-width="100" class="rounded-xl" />
        </div>
        <div>
          <v-btn icon rounded color="red" @click="removeImg">
            <img src="/img/trash.svg" width="30px"/>
          </v-btn>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import MediaGallery from "../../../../../../src/packages/gallery/MediaGallery";

export default {
  name: "AddImage",
  props: { image: String, imageDimension: Object },
  computed: {
    hasImage() {
      return !!this.image;
    }
  },

  components: { MediaGallery },
  methods: {
    selectedImage(img) {
      this.$emit('selectedImage', img.imageSrc);
    },
    removeImg() {
      this.$emit('selectedImage', null);
    }
  }
}
</script>

<style scoped>

</style>
